import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { ValueObject, Result, BadInputError } from '@digibricks/domains';
export var ConversationTag = /*#__PURE__*/function (_ValueObject) {
  _inherits(ConversationTag, _ValueObject);

  var _super = _createSuper(ConversationTag);

  function ConversationTag() {
    _classCallCheck(this, ConversationTag);

    return _super.apply(this, arguments);
  }

  _createClass(ConversationTag, [{
    key: "key",
    get: function get() {
      return this.props.key;
    }
  }, {
    key: "value",
    get: function get() {
      return this.props.value;
    }
  }], [{
    key: "isValid",
    value: function isValid(props) {
      return props.key.length > 0 && props.key.length <= this.maxKeyLength && props.value.length <= this.maxValueLength;
    }
  }, {
    key: "create",
    value: function create(key, value) {
      var props = {
        key: key.trim(),
        value: value.trim()
      };

      if (!this.isValid(props)) {
        return new BadInputError("Tag key must be 1-".concat(this.maxKeyLength, " chars, value max ").concat(this.maxValueLength, " chars"));
      }

      return Result.ok(new ConversationTag(props));
    }
  }]);

  return ConversationTag;
}(ValueObject);

_defineProperty(ConversationTag, "maxKeyLength", 50);

_defineProperty(ConversationTag, "maxValueLength", 200);